import React, { useCallback, useEffect, useState } from 'react';

// One practice for this person, chosen from their weekly check-in and their
// Doxyseren Index. It appears once they have a pilot check-in on record.
const PilotSuggestion = ({ context, palette, onStart, onShown }) => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  const base = '/api/v1/journey/suggestion';
  const q = '?context=' + encodeURIComponent(context || '');

  const load = useCallback((path, method) => {
    if (!token || !context) return Promise.resolve();
    return fetch(base + path + q, { method: method || 'GET', headers: { Authorization: 'Bearer ' + token } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d) setS(d.show ? d : null); })
      .catch(() => {});
  }, [context, token, q]);

  useEffect(() => {
    load('');
    const again = () => load('');
    window.addEventListener('fho5-saved', again);
    return () => window.removeEventListener('fho5-saved', again);
  }, [load]);

  useEffect(() => { if (onShown) onShown(!!s); }, [s, onShown]);

  if (!s) return null;

  const another = () => { setBusy(true); load('/another', 'POST').finally(() => setBusy(false)); };
  const start = () => {
    fetch(base + '/started' + q, { method: 'POST', headers: { Authorization: 'Bearer ' + token } }).catch(() => {});
    onStart("I'd like to try the practice suggested for me: " + s.title + '.');
  };

  const box = { maxWidth: '720px', margin: '12px auto 0', padding: '16px 22px', borderRadius: '14px',
    border: `1px solid ${palette.border}`, borderLeft: `5px solid ${palette.primary}`, background: 'rgba(0,0,0,0.25)', textAlign: 'left' };
  const btn = { padding: '10px 22px', borderRadius: '10px', fontSize: '16px', cursor: 'pointer', fontFamily: 'inherit' };

  return (
    <div style={box}>
      <div style={{ color: palette.primary, fontSize: '14px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase' }}>Suggested for you</div>
      <div style={{ color: palette.textPrimary, fontSize: '22px', fontWeight: 700, lineHeight: 1.25, marginTop: '2px' }}>{s.title}</div>
      <div style={{ color: palette.textSecondary, fontSize: '15px', marginTop: '2px' }}>{s.domain_name} · {s.type_label}. {s.reason_line}</div>
      <div style={{ color: palette.textPrimary, fontSize: '17px', lineHeight: 1.55, margin: '8px 0 0' }}>{s.does}</div>
      {s.origin && (
        <div style={{ color: palette.textSecondary, fontSize: '15px', lineHeight: 1.5, marginTop: '8px', fontStyle: 'italic' }}>{s.origin}</div>
      )}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '12px' }}>
        <button type="button" onClick={start} style={{ ...btn, border: 'none', background: palette.primary, color: (palette.onPrimary || '#1f1b18'), fontWeight: 700 }}>Try it with SAFE</button>
        <button type="button" onClick={another} disabled={busy} style={{ ...btn, border: `1px solid ${palette.border}`, background: 'transparent', color: palette.textPrimary, opacity: busy ? 0.6 : 1 }}>Show me another</button>
      </div>
    </div>
  );
};

export default PilotSuggestion;
